<div class="section-1 mat-padding-2">
  <div class="container">
    <div class="text-center mat-display-1 bold title-1 read">
      Le Robert, la marque de référence en matière de pédagogie et de langue
      française
    </div>

    <div
      fxLayout="row"
      fxLayout.xs="column"
      fxLayout.sm="col"
      fxLayoutAlign.xs="center center"
      fxLayoutAlign="center"
      fxLayoutGap="16px"
      fxLayoutGap.xs="64px"
    >
      <ng-container *ngFor="let item of items; index as i; let last = last">
        <div class="text-center item">
          <div class="circle">
            <img
              height="66"
              [src]="'/assets/lerobert/img/landing/' + (i + 1) + '@2x.png'"
            />
          </div>
          <div class="mat-h3 bold">
            {{ item.title }}
          </div>
          <div>
            {{ item.text }}
          </div>
        </div>

        <div *ngIf="!last" fxHide.xs fxHide.sm class="chevron">
          <mat-icon>chevron_right</mat-icon>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="section-2 mat-padding-2">
  <div class="container"></div>
  <div class="text-center mat-display-2 bold read">
    Optez pour l’offre complète CPF
  </div>

  <hr />

  <div class="text-center mat-h1 read">
    Notre offre de formation, unique en son genre, combine
    <b>trois services de référence</b> pour vous faire
    <b>progresser en un temps record</b> et vous permettre de
    <b>conserver ces acquis dans la durée :</b>
  </div>

  <div
    class="cards"
    fxLayout="row wrap"
    fxLayout.xs="column"
    fxLayoutGap.xs="64px"
    fxLayoutAlign="center center"
    fxLayoutAlign.xs="center center"
    fxLayoutGap="32px grid"
  >
    <ng-container *ngFor="let item of items2; index as i; last as last">
      <div>
        <div class="card-1 mat-padding-2">
          <div class="content">
            <div class="index">
              <div class="index-content text-center">0{{ i + 1 }}</div>
            </div>

            <div class="mat-h1 text-center bold" [innerHtml]="item.title"></div>

            <div class="img">
              <img
                [src]="'/assets/lerobert/img/landing/' + item.img + '@2x.png'"
              />
            </div>

            <br />
            <div fxLayout="column" fxLayoutGap="4px">
              <div
                *ngFor="let item of item.items"
                fxLayout="row"
                fxLayoutGap="4px"
              >
                <div>
                  <mat-icon style="margin-top: 4px;" class="blue small"
                    >check</mat-icon
                  >
                </div>

                <div [innerHtml]="item | safe: 'html'"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="add" fxHide.lt-md *ngIf="!last">
        <mat-icon>add_circle</mat-icon>
      </div>
    </ng-container>
  </div>

  <div
    class="text-center mat-display-1 white read"
    style="margin-top: 42px"
    fxLayout="row"
    fxLayoutAlign="center"
  >
    <div class="chevron first">
      <mat-icon
        style="font-size: 36px;
      height: 36px;
      width: 36px;
      color: white;"
        >chevron_right</mat-icon
      >
    </div>
    <div>
      Notre technologie au service de votre apprentissage
    </div>
  </div>

  <div
    fxLayout.xs="column"
    fxLayoutAlign.xs="center center"
    fxLayout.sm="column"
    fxLayoutAlign.sm="center center"
    fxLayout="row"
    fxLayoutAlign="center"
  >
    <ng-container *ngFor="let item of items3; let last = last">
      <div class="mat-padding-2 card">
        <div class="mat-h1 bold white text-center">
          {{ item.title }}
        </div>
        <hr class="sub" />

        <div class="mat-h4 white text-center">
          {{ item.text }}
        </div>
      </div>

      <div *ngIf="!last" fxHide.xs class="chevron second">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </ng-container>
  </div>
</div>

<div class="section-3">
  <div class="container">
    <div class="text-center mat-display-1 bold read">
      Choisissez votre parcours et commencez dès aujourd’hui à vous entraîner
    </div>
  </div>
</div>

<div class="section-4">
  <div class="bg"></div>

  <div class="container">
    <div
      fxLayout.xs="column"
      fxLayout="row"
      fxLayoutGap="32px"
      fxLayoutAlign="center"
    >
      <div
        fxLayout="column"
        *ngFor="let item of items4; index as i"
        class="card"
      >
        <div
          class="img-bg"
          [style.background-image]="
            'url(/assets/lerobert/img/landing/bg-' + (i + 1) + '@2x.png)'
          "
        ></div>

        <div class="mat-padding">
          <div class="title text-center mat-h1 bold">
            {{ item.title }}
          </div>

          <div class="text-center mat-h3 bold">
            {{ item.text }}
          </div>

          <div fxLayout="column" fxLayoutGap="8px">
            <div *ngFor="let i of item.items; first as first">
              <div fxLayout="row" fxLayoutGap="4px">
                <div>
                  <mat-icon class="blue">
                    <ng-container *ngIf="first">
                      check_circle
                    </ng-container>

                    <ng-container *ngIf="!first">
                      add_circle
                    </ng-container>
                  </mat-icon>
                </div>

                <div class="mat-body-2">
                  {{ i.title }}

                  <div>
                    <div
                      *ngFor="let ii of i.items"
                      fxLayout="row"
                      fxLayoutGap="4px"
                    >
                      <div>
                        <mat-icon class="blue small">check</mat-icon>
                      </div>

                      <div class="mat-body-1">
                        {{ ii }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span fxFlex></span>
        <div class="button text-center">
          <a
            *ngIf="item.button.routerLink"
            class="lerobert"
            mat-raised-button
            color="primary"
            [routerLink]="item.button.routerLink"
          >
            {{ item.button.text }}
          </a>

          <a
            *ngIf="item.button.link"
            class="lerobert"
            mat-raised-button
            color="primary"
            target="blank"
            [href]="item.button.link"
          >
            {{ item.button.text }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<polylearn-lerobert-footer></polylearn-lerobert-footer>
